/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * APIError.ts
 */

export default class APIError implements Error {
    status: number;
    message: string;
    name: string;

    constructor(name: string, status: number, message: string) {
        this.name = name;
        this.message = message;
        this.status = status;
    }

}